import { render, staticRenderFns } from "./IntelligenceDeliveryTable.vue?vue&type=template&id=2afec702&scoped=true"
import script from "./IntelligenceDeliveryTable.vue?vue&type=script&lang=js"
export * from "./IntelligenceDeliveryTable.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceDeliveryTable.vue?vue&type=style&index=0&id=2afec702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afec702",
  null
  
)

export default component.exports